/** react query keys */
export const QUERY_KEYS = {
  extractItemList: "EXTRACT_ITEM_LIST",
  ruleList: "RULE_LIST",
  operators: "OPERATORS",
  splitResult: "SPLIT_RESULT",
  splitImageList: "SPLIT_IMAGE_LIST",
  flowDetail: "FLOW_DETAIL",
  crossTemplateDetail: "CROSS_TEMPLATE_DETAIL",
  crossTaskDetail: "CROSS_TASK_DETAIL",
  templateGroup: "TEMPLATE_GROUP",
  templateList: "TEMPLATE_LIST",
  templateDetail: "TEMPLATE_DETAIL",
  favoriteTemplateList: "FAVORITE_TEMPlLATE_LIST",
  recommendTemplateList: "RECOMMEND_TEMPLATE_LIST",
  customTemplateList: "CUSTOM_TEMPLATE_LIST",
  workspaceList: "WORKSPACE_LIST",
  messageList: "MESSAGE_LIST",
  taskList: "TASK_LIST",
  taskDetail: "TASK_DETAIL",
  analysisResult: "ANALYSIS_RESULT",
  userTagList: "USER_TAG_LIST",
  pdfInfo: "PDF_INFO",
  pageInfo: "PAGE_INFO",
  rowInfo: "ROW_INFO",
  itemsInfo: "ITEMS_INFO",
  txtInfo: "TXT_INFO",
  tableInfo: "TABLE_INFO",
  chatBySource: "CHAT_BY_SOURCE",
  chat: "CHAT",
  groupList: "GROUP_LIST",
  dataSourceList: "DATA_SOURCE_LIST",
  customFunctionList: "CUSTOM_FUNCTION_LIST",
  tableTemplateDetail: "TABLE_TEMPLATE_DETAIL",
  tableTaskDetail: "TABLE_TASK_DETAIL",
  tagList: "TAG_LIST",
  annotatedList: "ANNOTATED_LIST",
  workflow: "WORKFLOW",
  taggingList: "TAGGING_LIST",
  ReviewFeedbackInfo: "REVIEW_FEEDBACK_INFO",
} as const;

/** HTTP methods */
export const REQUEST_METHODS = {
  get: "GET",
  post: "POST",
  put: "PUT",
  delete: "DELETE",
  head: "HEAD",
  options: "OPTIONS",
  connect: "CONNECT",
  patch: "PATCH",
} as const;

/** nice modal register keys */
export const DIALOG_KEYS = {
  precondition: "PRECONDITION",
} as const;

/**
 * 创建任务需要template_category参数的模板类型
 * **/
export const needTemplateCategoryParam = ["KEYWORD", "REVIEW", "EXTRACTION"]